import React from 'react';
import SafeIcon from '../common/SafeIcon';

const MobileStickyCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-xl border-t border-brand-border z-50 md:hidden">
      <a 
        href="https://wa.me/65988702334" 
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-3 w-full bg-brand-black text-brand-white py-5 rounded-lg font-bold tracking-wide shadow-2xl shadow-brand-black/20 active:scale-95 transition-transform"
      >
        <SafeIcon name="MessageCircle" /> WhatsApp Now
      </a>
    </div>
  );
};

export default MobileStickyCTA;